import React, { useEffect, useRef, useState } from "react";
import { FormControl, InputAdornment, TextField } from "@mui/material";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import { Place } from "../../../../@Types/ComponentsInterface/OrderSelectProps";
import DropMarkerModal from "../../../Modals/DropMarkerModal";
interface GPlaceProps {
  onPlaceSelect: (place: Place | null) => void;
  value?: Place;
  onPinChange: (changedLocationDetails: Place) => void;
}

const GPlace: React.FC<GPlaceProps> = ({
  onPlaceSelect,
  value,
  onPinChange,
}) => {
  const placeInputRef = useRef<HTMLInputElement>(null);
  const [apiLoaded, setApiLoaded] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState(value?.address || "");

  useEffect(() => {
    setTextFieldValue(value?.address || "");
  }, [value]);

  useEffect(() => {
    loadGoogleMapScript();
  }, []);

  const googleMapApiKey = "YOUR_GOOGLE_MAPS_API_KEY"; // Replace with your Google Maps API Key

  const loadGoogleMapScript = () => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      const googleMapScript = document.createElement("script");
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}&libraries=places`;
      googleMapScript.onload = () => {
        setApiLoaded(true);
      };
      document.body.appendChild(googleMapScript);
    } else {
      setApiLoaded(true);
    }
  };

  useEffect(() => {
    if (apiLoaded && placeInputRef.current) {
      initPlaceAPI(onPinChange);
    }
  }, [apiLoaded, onPinChange]);

  const initPlaceAPI = (
    onPinChange: (changedLocationDetails: Place) => void
  ) => {
    let autocomplete = new window.google.maps.places.Autocomplete(
      placeInputRef.current as HTMLInputElement,
      {}
    );

    autocomplete.addListener("place_changed", function () {
      let place = autocomplete.getPlace();
      const offset = place?.utc_offset_minutes
        ? place.utc_offset_minutes / 60
        : 0;

      let address1 = value?.address || "";
      let postcode = value?.postcode || "";
      let country = value?.country || "";
      let administrative_area_level_1 =
        value?.administrative_area_level_1 || "";
      let city = value?.city || "";

      for (const component of place?.address_components || []) {
        address1 = `${address1} ${component.long_name}`;
        const componentType = component.types[0];

        switch (componentType) {
          case "administrative_area_level_1":
            administrative_area_level_1 = `${component.long_name}`;
            break;
          case "postal_code":
            postcode = `${component.long_name}`;
            break;
          case "locality":
            city = `${component.long_name}`;
            break;
          default:
            country = component.long_name;
            break;
        }
      }

      const selectedPlace: Place = {
        country,
        postcode,
        utc_offset: offset,
        address: address1,
        administrative_area_level_1,
        city,
        lat: place?.geometry?.location?.lat() || 0,
        lng: place?.geometry?.location?.lng() || 0,
      };

      onPlaceSelect(selectedPlace);
      onPinChange(selectedPlace);
    });
  };

  return (
    <>
      <FormControl fullWidth>
        <TextField
          label="Drop Location"
          id="standard-size-small"
          defaultValue=""
          size="small"
          inputRef={placeInputRef}
          value={textFieldValue}
          onChange={(e) => {
            setTextFieldValue(e.currentTarget.value);
          }}
          InputLabelProps={{
            style: { color: "#ACACAC" },
            shrink: true,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <DropMarkerModal
                  onPinChange={(changedLocationDetails) => {
                    setTextFieldValue(changedLocationDetails.address);
                    onPinChange(changedLocationDetails);
                  }}
                  latit={value?.lat}
                  lngit={value?.lng}
                />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
      </FormControl>
    </>
  );
};

export default GPlace;
